import styled from 'styled-components';
import {Space} from 'antd';

const StyledCardDetails = styled(Space)`
  width: 100%;
`;

const StyledCardDetailsActions = styled.div`
  align-items: center;
  background-color: ${props => props.theme.colors.neutral_2};
  border-radius: 16px;
  display: flex;
  justify-content: space-between;
  padding: 20px 16px;
  width: 100%;
  
  .unfreeze-card {
    &:not(:hover) {
      & > div {
        &:first-of-type {
          background-color: ${props => props.theme.colors.primary_6};
        }
      }

      svg {
        path {
          fill: ${props => props.theme.colors.neutral_1};
        }
      }
    }
  }
  
  .delete-card {
    svg {
      path {
        fill: ${props => props.theme.colors.neutral_7};
      }
    }
    
    &:hover {
      & > div {
        &:first-of-type {
          background-color: ${props => props.theme.colors.neutral_3};
        }
      }
      svg {
        path {
          fill: ${props => props.theme.colors.functional_danger};
        }
      }
    }
  }
`;

export {
  StyledCardDetails,
  StyledCardDetailsActions
}
